import React from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import './App.css';
import {AuthProvider} from './context/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Login from './pages/Login/Login';
import SalesRepHome from './pages/SalesRep/Home/SalesRepHome';
import SalesRepTickets from './pages/SalesRep/Tickets/SalesRepTickets';
import SalesRepHistory from './pages/SalesRep/History/SalesRepHistory';
import Logout from './components/Logout/Logout';
import Unauthorized from "./components/Unauthorized/Unauthorized";
import SysadminHome from "./pages/Sysadmin/Home/SysadminHome";
import './styles/styles.css'
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SysadminDashboard from "./pages/Sysadmin/Dashboard/SysadminDashboard";
import SysadminUsers from "./pages/Sysadmin/Users/SysadminUsers";
import AdministrativeHome from "./pages/Administrative/Home/AdministrativeHome";
import AdministrativeTickets from "./pages/Administrative/Tickets/AdministrativeTickets";
import AdministrativeClients from "./pages/Administrative/Clients/AdministrativeClients";
import AdministrativeEquipments from "./pages/Administrative/Equipments/AdministrativeEquipments";
import AdminstrativeComponents from "./pages/Administrative/Components/AdministrativeComponents";
import AdministrativeAdditives from "./pages/Administrative/Additives/AdministrativeAdditives";
import AdministrativeHistory from "./pages/Administrative/History/AdministrativeHistory";
import SupervisorHome from "./pages/Supervisor/Home/SupervisorHome";
import SupervisorTickets from "./pages/Supervisor/Tickets/SupervisorTickets";
import TechnicianTickets from "./pages/Technician/Tickets/TechnicianTickets";
import TechnicianHome from "./pages/Technician/Home/TechnicianHome";


function App() {
    return (
        <AuthProvider>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Navigate to="/login" replace/>}/>
                    <Route path="/login" element={<Login/>}/>

                    <Route
                        path="/salesrep/home"
                        element={
                            <ProtectedRoute allowedRoles={['salesrep']}>
                                <SalesRepHome/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="tickets" replace/>}/>
                        <Route path="tickets" element={<SalesRepTickets/>}/>
                        <Route path="history" element={<SalesRepHistory/>}/>
                        <Route path="logout" element={<Logout/>}/>
                    </Route>

                    <Route
                        path="/sysadmin/home"
                        element={
                            <ProtectedRoute allowedRoles={['sysadmin']}>
                                <SysadminHome/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="dashboard" replace/>}/>
                        <Route path="dashboard" element={<SysadminDashboard/>}/>
                        <Route path="users" element={<SysadminUsers/>}/>
                        <Route path="logout" element={<Logout/>}/>
                    </Route>

                    <Route
                        path="/administrative/home"
                        element={
                            <ProtectedRoute allowedRoles={['administrative']}>
                                <AdministrativeHome/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="tickets" replace/>}/>
                        <Route path="tickets" element={<AdministrativeTickets/>}/>
                        <Route path="clients" element={<AdministrativeClients/>}/>
                        <Route path="additives" element={<AdministrativeAdditives/>}/>
                        <Route path="equipments" element={<AdministrativeEquipments/>}/>
                        <Route path="components" element={<AdminstrativeComponents/>}/>
                        <Route path="history" element={<AdministrativeHistory/>}/>
                        <Route path="logout" element={<Logout/>}/>
                    </Route>

                    <Route
                        path="/supervisor/home"
                        element={
                            <ProtectedRoute allowedRoles={['supervisor']}>
                                <SupervisorHome/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="tickets" replace/>}/>
                        <Route path="tickets" element={<SupervisorTickets/>}/>
                        <Route path="clients" element={<AdministrativeClients/>}/>
                        <Route path="additives" element={<AdministrativeAdditives/>}/>
                        <Route path="equipments" element={<AdministrativeEquipments/>}/>
                        <Route path="components" element={<AdminstrativeComponents/>}/>
                        <Route path="history" element={<AdministrativeHistory/>}/>
                        <Route path="logout" element={<Logout/>}/>
                    </Route>

                    <Route
                        path="/technician/home"
                        element={
                            <ProtectedRoute allowedRoles={['technician']}>
                                <TechnicianHome/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="tickets" replace/>}/>
                        <Route path="tickets" element={<TechnicianTickets/>}/>
                        <Route path="logout" element={<Logout/>}/>
                    </Route>

                    <Route path="/unauthorized" element={<Unauthorized/>}/>
                    <Route path="*" element={<Navigate to="/login" replace/>}/>
                </Routes>
                <ToastContainer/>
            </div>
        </AuthProvider>
    );
}

export default App;
